import SlotSecondPageModel from './slot-second-page.model';
import { AppInjector } from '../utils/services/set-app-injector';
import { LoadersService } from '../utils/loaders/loaders.service';
import { SlotsValidationService } from '../order-fulfillment/slots-validation.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../cart-process/common-info.service';
import { TrafficTypeEnum } from './cartDetails/trafficType.model';
import SlotStateService from '../cart-process/slot-state.service';
import { CartDetailsSourceIdsEnum } from './cartDetails/data-source-ids.enum';
import { DataLayerService } from '../customer-actions/data-layer.service';
import { IBundle } from '../interfaces/cart-details.interface';
import { ProcessTypeEnum } from './cartDetails/process-type.enum';
import { ConfigService } from '../cart-process/config.service';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';
import { ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';

export default class SlotFirstPageModel extends SlotSecondPageModel {

  public additionalDescription: string;
  public changeDeviceUrl: string;
  public bundleNumber: number;
  public showRemoveLink: boolean;
  public isAddTerminalLinkVisible: boolean;
  public isLoaderVisible = false;
  public showMessages: boolean;
  public newSlotHide: boolean;
  public newSlotShowFromBottom: boolean;
  public messages: any;
  public isVoiceOffer: boolean;
  public isDataOffer: boolean;
  public ifOfferHasGadget: boolean;
  public isTvOffer = false;
  public showDeviceSection = false;
  public keepGadgets: string;

  private loadersService: LoadersService = AppInjector.get(LoadersService);
  private endpoint: any = AppInjector.get('Endpoint');
  private slotsValidationService: SlotsValidationService = AppInjector.get(SlotsValidationService);
  private notificationProvider: NotificationProviderService = AppInjector.get(NotificationProviderService);
  private slotsState: any = AppInjector.get(SlotStateService);
  private dataLayerService: DataLayerService = AppInjector.get(DataLayerService);
  private externalInterfacesService: ExternalInterfacesService = AppInjector.get(ExternalInterfacesService);

  constructor(
    bundle: IBundle,
    ordinal: number,
    ordinalNumberInGroup: number,
  ) {
    super(bundle, ordinal, ordinalNumberInGroup);

    this.showRemoveLink = !bundle.obligatory;
    this.additionalDescription = bundle.offer.additionalDescription || '';
    this.bundleNumber = bundle.number;
    this.showMessages = !!(bundle.messages && bundle.messages.messages && bundle.messages.messages.length);
    this.newSlotHide = bundle.newSlotHide;
    this.newSlotShowFromBottom = bundle.newSlotShowFromBottom;
    this.messages = bundle.messages;
    this.isVoiceOffer = this.trafficType === TrafficTypeEnum.VOICE;
    this.isDataOffer = this.trafficType === TrafficTypeEnum.DATA;
    this.ifOfferHasGadget = this.hasGadget;
    this.isTvOffer = this.isTrafficTypeTV();
    this.showDeviceSection = this.hasDevice || this.isTvOffer;
    this.keepGadgets = this.ifOfferHasGadget ? `&keepGadgets=${this.ifOfferHasGadget}`: '';

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CONFIG,
      (config: ConfigService) => {
        if (!config) return;

        this.changeDeviceUrl = `${config.changeDeviceUrl}?bundleNo=${this.bundleNumber}&oid=${bundle.offer.handsetOfferIdForChangeDevice}${this.keepGadgets}`;
      }
    );

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfo: CommonInfoService) => {
        if (!commonInfo) {
          return;
        }

        this.setIsAddTerminalLinkVisible();
      }
    );

    this.setIsAddTerminalLinkVisible();
  }

  public deleteDevice($event: MouseEvent) {
    $event.preventDefault();

    if (this.ifOfferHasGadget) {
      this.deleteSlotDeviceModal();

      return;
    }

    this.changeDeviceEndpoint();
  }

  public chooseDevice($event: MouseEvent) {
    $event.preventDefault();

    const FOCUS_BUNDLE_ITEM_NAME = 'focusedBundleNumber';

    localStorage.setItem(FOCUS_BUNDLE_ITEM_NAME, String(this.bundleNumber));

    location.href = this.changeDeviceUrl;
  }

  public isValid(): boolean {
    let isValid = true;

    // manage TV on slot
    if (this.isTvOffer || this.hasTvAddon && this.commonInfoService.isSolo && this.isDataOffer) {
      isValid = this.manageTv.isValid();
    }

    // processes state - valid
    if (
      !(this.isOwner && this.commonInfoService.processType === ProcessTypeEnum.CART_BOHO)
      && !this.slotsState.isValidByBundleNumber(this.bundleNumber)
      && !this.isTvOffer
    ) {
      const state = this.slotsState.getTempState(this.bundleNumber);

      this.slotsValidationService.slotValidate(state);

      isValid = false;
    }

    return isValid;
  }

  private setIsAddTerminalLinkVisible(): void {
    this.isAddTerminalLinkVisible = !this.hasDevice && this.possibleChangeDevice && (this.isVoiceOffer || this.isDataOffer);
  }

  private deleteSlotDeviceModal(): void {
    const modalData = {
      templateName: CommonModalTemplatesEnum.REMOVE_SET_CONFIRMATION_MODAL,
      gadgetsList: this._computedFields.gadgetsList,
      deviceItem: this.device,
      remove: ($event: MouseEvent) => {
        $event.preventDefault();

        this.commonModalService.removeModal(CommonModalTemplatesEnum.REMOVE_SET_CONFIRMATION_MODAL);

        this.changeDeviceEndpoint();
      }
    };

    this.commonModalService.setData(modalData);
  }

  private changeDeviceEndpoint(): void {
    this.loadersService.start(this.loadersService.loaderActions.SLOT_LOADER + this.slotNo);

    this.dataLayerService.generateToken(CartDetailsSourceIdsEnum.REMOVE_DEVICE);

    this.dataLayerService.onRemoveOptionalSlotDevice(this.uid);

    this.endpoint('newCart.changeDevice', {
      offerId: this.offerId,
      bundleNo: this.bundleNumber
    }).queue()
      .run()
      .then((serverResponse: string) => {
        if (serverResponse === 'OK') {
        this.externalInterfacesService.updateCartDetails(CartDetailsSourceIdsEnum.REMOVE_DEVICE, this.dataLayerService.getToken(CartDetailsSourceIdsEnum.REMOVE_DEVICE));
        this.loadersService.stop(this.loadersService.loaderActions.SLOT_LOADER + this.slotNo);
      }
    });
  }
}

